var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"blank"},[_c('h1',[_vm._v("404 页面不存在")]),_c('p',[_vm._v("您访问的页面不存在，请返回 "),_c('router-link',{attrs:{"to":"/home"}},[_vm._v("首页")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }